import { render } from "./onboarding-overview.vue?vue&type=template&id=534264ba&lang=pug"
import script from "./onboarding-overview.vue?vue&type=script&lang=js"
export * from "./onboarding-overview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__